import { Button, Div, Icon } from "@grassrootly/rn-core";
import { ScreenLayout } from "../../layout/components";
import { MainStackScreenProps } from "../../navigation/Navigation.types";
import { useMyGroups } from "./useMyGroups";
import MyGroupsList from "./MyGroupsList";

export default function MyGroupsScreen({ navigation }: MainStackScreenProps<"my-groups">) {
  const { groups, loading } = useMyGroups();
  const onGroupPress = (id: number) => {
    navigation.navigate("group", { id });
  };
  const onPressCreateGroup = () => {
    navigation.navigate("create-group");
  };
  const onPressJoinGroup = () => {
    navigation.navigate("join-group");
  };

  return (
    <ScreenLayout
      header={{ center: "MY TEAMS", left: <Icon name="menu" size={24} onPress={navigation.toggleDrawer} /> }}
    >
      <Div classNames={["flexRow", "alignItemsCenter", "justifyContentFlexEnd", "gap16", "mb-{15}"]}>
        <Button
          title="Create Team"
          right={{ name: "add" }}
          onPress={onPressCreateGroup}
          classNames={["minH-{24}", "pb-{9}", "pt-{9}"]}
        />
        <Button
          title="Join Team"
          classNames={["btn", "btnOutlinePrimary", "minH-{23}", "pv8"]}
          right={{ name: "group_add" }}
          onPress={onPressJoinGroup}
        />
      </Div>
      <MyGroupsList groups={groups} loading={loading} onGroupPress={onGroupPress} />
    </ScreenLayout>
  );
}
